import type { ApiConfig } from '@portals-platform/brand-kit';
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { normalizeError } from './errors.js';

export function createApiClient(config: ApiConfig): AxiosInstance {
  const instance = axios.create({
    baseURL: config.baseUrl,
    timeout: config.timeoutMs ?? 30_000,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  // Response error normalization
  instance.interceptors.response.use(
    (response) => response,
    (error: unknown) => Promise.reject(normalizeError(error)),
  );

  return instance;
}
